import styled from 'styled-components';
import { Card } from 'elmo-elements';
import applicationBg from './assets/dashboard-bg.svg';

export const LayoutWrapper = styled.div`
  background-image: url(${applicationBg});
  background-position: center center;
  background-size: cover;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.14);
  height: 100vh;

  .elmo-layout__main-content-wrapper {
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  // flex-direction: column;
  // justify-content: space-between
`;

export const HeaderLogo = styled.img`
  // align-self: flex-start;
`;

export const UserName = styled.div`
  font-size: 16px;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    display: none;
  }
`;

export const MoreInfo = styled.div`
  posistion: absolute;
  top: 0;
  right: 0;
`;

export const UserDetailsBox = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  img {
    border-radius: 50%;
    margin: 0 10px;
    width: 32px;
  }
`;

export const VPNSectionStyled = styled(Card)`
  &.vpn-section {
    width: 60vw;
    margin: 0 auto;
    margin-bottom: 40px;
    padding: 12px 15px;

    .elmo-card__content-inner {
      color: #212121;
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      align-items: center;

      .vpn-section__requirement {
        display: flex;
        align-items: center;

        &--warning-icon {
          color: #b1101e;
          margin-right: 10px;

          .elmo-icon__svg {
            font-size: 28px;
          }
        }
      }

      @media only screen and (max-device-width: 1024px) {
        flex-direction: column;
      }
    }
  }
`;

export const AppBox = styled(Card)`
  display: flex;
  align-items: left;
  justify-content: left;
  height: 350px;
  transition: outline 250ms;
  border-color: 250ms background-color 250ms color 250ms box-shadow 250ms;
  cursor: pointer;
  color: #19579f;
  margin-bottom: 30px;
  :hover {
    background-color: #e6f1ff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.14);
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    align-items: center;
    justify-content: center;
    text-align: center !important;

    h3 {
      text-align: center !important;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    align-items: center;
    justify-content: center;
    text-align: center !important;

    h3 {
      text-align: center !important;
      margin: 15px 0 5px 0;
    }

    img {
      width: 140px;
    }
  }

  h3 {
    margin: 35px 0 15px 0;
  }
`;

export const ApplicationsHeading = styled.div`
  padding: 0 !important;
  margin: 150px 0 30px 0 !important;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    margin: 70px 0 30px 0 !important;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    margin: 70px 0 30px 0 !important;
  }

  h4 {
    font-size: 33px !important;
    color: #212121 !important;
    margin: 0 0 60px 0;
    span {
      color: #8c8c8c;
    }

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
      margin: 0 0 30px 0;
    }

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
      margin: 0 0 50px 0;
    }
  }
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 20px;
  text-align: center;
  width: 100%;
  color: #8c8c8c;

  span {
    color: #212121;
  }
`;
